import { Slide } from "@jelly/lesson";

import { task as task02 } from "../../../../../task/course-05/lesson-23/task-02";

const task: Slide = {
  title: "What does the proposal described in this lesson hope to achieve?",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task02.id,
        },
      },
    },
  },
};

export default task;
